import React, { useEffect, useState } from "react";
import Dropdown from "../components/Form/Dropdown";
import { searchableDropdownOptionsForTesting } from "../Data/Data";
import Button from "../components/Form/CustomButton";
import CustomDatePicker from "../components/Form/CustomDatePicker";
import { MdOutlineMood } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import MultiSelectDropDown from "../components/Form/MultiSelectDropDown";
import ImageUpload from "../components/Form/ImageUpload";
import CustomTimePicker from "../components/Form/CustomTimePicker";
import ProfileImageUploader from "../components/Form/ProfileImageUploader";
import FormSectionHeading from "../components/Form/FormSectionHeading";
import Input from "../components/Form/Input";
import {
  firebaseUplaodFolders,
  referencesFormats,
} from "../constants/commonConstants";
import useFirebaseFileUpload from "../hooks/useFirebaseFileUpload";
import showToast from "../utils/toastNotifications";

const TestReusableComponents = () => {
  const [
    doUploadRefrencesToFirebase,
    isUploadRefrencesToFirebaseLoading,
    uploadRefrencesToFirebaseError,
  ] = useFirebaseFileUpload();

  const [searchParams, setSearchParams] = useSearchParams({
    category: "",
  });
  const [selectedCategory, setSelectedCategory] = useState(
    searchableDropdownOptionsForTesting.find(
      (option) => option.id === Number(searchParams.get("category"))
    ) || null
  );
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    const params = {
      category: selectedCategory?.id,
    };
    setSearchParams(params);
  }, [selectedCategory, searchParams]);

  const handleSelectedCategory = (category) => {
    setSelectedCategory(category);
  };

  const getSelectedDate = (date) => {
    const formattedDate = selectedDate.format("YYYY-MM-DD");
    const year = selectedDate.year();
    const month = selectedDate.month() + 1; // Note: zero-indexed
    const day = selectedDate.date();

    setSelectedDate(date);
  };

  console.log("selectedDate", selectedDate);

  console.log("selectedCategory: ", selectedCategory);

  const [uploadFiles, setUploadFiles] = useState([]);

  const onFileUpload = (files) => {
    setUploadFiles([...files]); // Ensure it's a new array
  };

  // Pick Time
  const [selectedTime, setSelectedTime] = useState("");

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    console.log("Selected Time:", time);
  };

  // MultiSelect
  const [multiSelect, setMultiSelect] = useState([]);

  const handleMultiSelect = (selectedOptions) => {
    setMultiSelect(selectedOptions);
  };

  const handleUploadFiles = async (e) => {
    e.preventDefault();

    const fileUploadResult = await doUploadRefrencesToFirebase(
      uploadFiles,
      firebaseUplaodFolders.F_REFERENCES
    );

    if (!fileUploadResult.success) {
      console.error("Upload Error:", fileUploadResult.error);
      showToast("error", "Failed to upload files");
      return;
    }

    const downloadURLs = fileUploadResult.uploadedUrls;

    console.log("uploadFiles", uploadFiles);
  };

  const [profilePictureFile, setProfilePictureFile] = useState(null);

  const handleUploadProfileImage = async (e) => {
    e.preventDefault();

    if (!profilePictureFile) {
      showToast("error", "Please select a profile image");
      return;
    }

    const fileUploadResult = await doUploadRefrencesToFirebase(
      [profilePictureFile],
      firebaseUplaodFolders.F_PROFILE_PICTURES
    );

    if (!fileUploadResult.success) {
      console.error("Upload Error:", fileUploadResult.error);
      showToast("error", "Failed to upload files");
      return;
    }

    const downloadURLs = fileUploadResult.uploadedUrls;
    // Handle the downloaded URLs (e.g., save to user profile)
    console.log("Uploaded profile picture URLs:", downloadURLs);
  };

  const handleProfileImageUpload = (file) => {
    setProfilePictureFile(file);
  };

  return (
    <div className="p-2 flex flex-col gap-8 mb-[500px]">
      <div className=" py-2 flex gap-4 w-[600px] items-center justify-center ">
        <Dropdown
          options={searchableDropdownOptionsForTesting}
          placeholder="Select an option"
          isSearchable={true}
          defaultOption={selectedCategory}
          onSelect={handleSelectedCategory}
          wrapperClassName="font-inter w-[400px]"
          buttonClassName="h-12 rounded-[8px]"
          dropdownClassName="rounded-md"
          optionClassName="text-primary hover:bg-primary-light"
          displayKey="value"
          idKey="id"
          label={`Category`}
        />
      </div>
      <div className=" py-2">
        <h1>Custom</h1>
        <Dropdown
          options={searchableDropdownOptionsForTesting}
          defaultOption={selectedCategory}
          displayKey="value"
          placeholder="Select Category"
          idKey="id"
          onSelect={handleSelectedCategory}
          wrapperClassName="w-full max-w-[745px] h-[56px] font-inter font-medium text-base"
          filterClassName="max-h-[240px] overflow-y-auto scrollbar-none"
          buttonClassName="px-10 border border-primary h-12 rounded-[20px] text-content"
          dropdownClassName="rounded-[22px] shadow-lg"
          optionClassName="px-10 py-3 hover:bg-gray-100 first:rounded-t-[20px] last:rounded-b-[20px]
                       text-content"
        />
      </div>
      <div className=" flex gap-4">
        <Button
          type="button"
          buttonText="Button"
          loading={false}
          onClick={handleUploadFiles}
          className=" bg-primary text-level-6 font-semibold text-white w-[120px] h-[46px] flex items-center justify-center rounded-xl"
        />
        <Button
          type="button"
          buttonText="Button"
          loading={true}
          loaderColor="var(--tertiary-color)"
          onClick={handleUploadProfileImage}
          className=" bg-primary text-level-6 font-semibold text-white w-[120px] h-[46px] flex items-center justify-center rounded-xl"
        />
        <Button
          type="button"
          buttonText="Become a Service Pro"
          bgColor="bg-white"
          borderColor="border-primary"
          textColor="text-primary"
          width="w-[200px]"
          height="h-12"
          loading={false}
        />
        <Button
          type="button"
          buttonText="Become a Service Pro"
          bgColor="bg-white"
          borderColor="border-primary"
          textColor="text-primary"
          width="w-[200px]"
          height="h-12"
          loading={true}
        />
        <Button
          type="button"
          buttonText="Post a Job"
          bgColor="bg-white"
          borderColor="border-primary"
          textColor="text-primary"
          width="w-[140px]"
          height="h-12"
          loading={false}
          icon={<MdOutlineMood size={20} />}
        />
        <Button
          type="button"
          buttonText="Post a Job"
          bgColor="bg-white"
          borderColor="border-primary"
          textColor="text-primary"
          width="w-[140px]"
          height="h-12"
          loading={false}
          icon={<MdOutlineMood size={20} />}
          iconPosition="right"
        />
      </div>
      <div className=" flex gap-3 items-center justify-center w-[400px]">
        <Button
          buttonText="Button"
          bgColor="bg-primary"
          textColor="text-white"
          width="w-full"
          height="h-[46px]"
          borderColor="border-transparent"
          loading={false}
        />
        <Button
          buttonText="Button"
          bgColor="bg-primary"
          textColor="text-white"
          width="w-full"
          height="h-[46px]"
          borderColor="border-transparent"
          loading={true}
        />
      </div>

      <div className=" grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 md:gap-12 gap-6">
        <CustomDatePicker
          label="Date of Birth"
          placeholder="Select Date"
          selectedDate={selectedDate}
          onChange={(date) => console.log("date: ", date)}
          isRequired={true}
          // outerContainerStyle="w-[320px]"
          pickerWidth="100%"
          pickerHeight="3rem"
        />

        <CustomTimePicker
          label={"Time"}
          isRequired={true}
          selectedTime={selectedTime}
          onChange={handleTimeChange}
        />

        <MultiSelectDropDown
          options={searchableDropdownOptionsForTesting}
          defaultSelected={multiSelect}
          onSelect={handleMultiSelect}
          label="Select"
          placeholder="multi select"
          isRequired={false}
          isDisabled={false}
          isSearchable={false}
          idKey="id"
          displayKey="value"
        />
      </div>

      <div className=" flex gap-6 max-w-[1024px] items-center justify-center">
        {/* <ImageUpload
          label="Upload Files"
          isRequired={true}
          labelStyle=""
          outerContainerStyle=""
          uploadFiles={uploadFiles}
          onFileUpload={onFileUpload}
          isLoading={false}
          uploadText="PDF, Excel are allowed"
          dragText="Drop your image here, or browse"
          error={null}
          accept={Object.values(referencesFormats)} // accept all formats
          borderStyle="border-dashed"
        /> */}
        {/* <ImageUpload
          label="Upload Files"
          isRequired={true}
          labelStyle=""
          outerContainerStyle=""
          uploadFiles={uploadFiles}
          onFileUpload={onFileUpload}
          isLoading={true}
          isDisabled={true}
          uploadText="Jpeg, Jpg, png are allowed"
          accept={[referencesFormats.JPEG_JPG, referencesFormats.PNG]}
          dragText="Drop your image here, or browse"
          error={null}
          borderStyle="border"
        /> */}

        <ProfileImageUploader
          label="Profile Image"
          isRequired={false}
          avatarContainerStyle="w-[119px]"
          imageStyle="w-[119px] h-[115px]"
          labelStyle="font-inter font-medium text-content"
          outerContainerStyle="flex flex-col gap-2"
          onImageUpload={handleProfileImageUpload}
          loading={isUploadRefrencesToFirebaseLoading}
        />
      </div>
      <FormSectionHeading index={4} title="Additional Requirement" />

      <Input
        label="Task Title"
        type="textarea"
        placeholder="Enter a concise task"
        outerContainerStyle="flex-grow"
        name="taskTitle"
        isRequired={true}
      />

      <div className="mt-12 mb-[88px] px-[20px] md:px-[40px] lg:px-[100px]">
        <ImageUpload
          label="Upload Files"
          isRequired={true}
          labelStyle=""
          outerContainerStyle=""
          uploadFiles={uploadFiles}
          onFileUpload={onFileUpload}
          uploadText="Jpeg, Jpg, png are allowed"
          accept={[
            referencesFormats.JPEG_JPG,
            referencesFormats.PNG,
            referencesFormats.PDF,
          ]}
          dragText="Drop your image here, or browse"
          borderStyle="border border-dashed"
          allowImageArrange={true}
          maximumSize={1}
          numberOfImages={2}
          isLoading={false}
          numberOfFiles={3}
        />
      </div>
    </div>
  );
};

export default TestReusableComponents;
